import React from 'react'
import PropTypes from 'prop-types'
import SidebarIcon from './../icons/SidebarIcon'
import './../../ui.style.scss'

const SidebarButton = ({ isDisabled, onClick, ...props }) => (
  <div className={`black-button sidebar ${isDisabled ? 'disabled' : ''}`} onClick={onClick} >
    <SidebarIcon />
  </div>
)

SidebarButton.propTypes = {
  /** disabled status of Button. */
  isDisabled: PropTypes.bool,
  /** Button click action. */
  onClick: PropTypes.func.isRequired
}

SidebarButton.defaultProps = {
  isDisabled: false
}

export default SidebarButton
